import { createRouter, createWebHistory } from 'vue-router'

export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/orders/:orderId/',
      name: 'New',
      component: { render: () => null }
    },
    {
      path: '/orders/:orderId/inquiries/thanks',
      name: 'Thanks',
      component: { render: () => null }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    // ハッシュがある時にはその地点へとスクロールする
    const selector = location.hash
    return selector ? { el: selector } : { top: 0, left: 0 }
  }
})
